"use client"

import { createContext, useContext, type ReactNode } from "react"

/**
 * Whether transcript tool calls should surface their tool name inline.
 *
 * This is a pure `src/shared` seam: it carries a single boolean and imports
 * nothing from `src/modules`. The value is sourced from the
 * `transcript-tool-call-names` feature flag by a module/app-shell provider
 * (see `src/modules/navigation/.../AppShellDomainContributionsRoute`), keeping
 * the shared transcript components free of any module dependency.
 *
 * Defaults to `false` so any transcript view rendered without a provider
 * (including unit tests) keeps the existing generic "Tool Call" labels.
 */
const ToolCallNameDisplayContext = createContext<boolean>(false)

export const ToolCallNameDisplayProvider = ({
  showToolCallNames,
  children,
}: {
  showToolCallNames: boolean
  children: ReactNode
}) => {
  return (
    <ToolCallNameDisplayContext.Provider value={showToolCallNames}>
      {children}
    </ToolCallNameDisplayContext.Provider>
  )
}

export const useShowToolCallNames = (): boolean =>
  useContext(ToolCallNameDisplayContext)
